module.exports = __webpack_public_path__ + "static/media/img-mygood-product-6@3x.af776954.png";